export default [
  {
    path: "AgentVersion",
    name: "AgentVersion",
    meta: {
      title: "代理商最新进销存数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentVersion/index.vue")
  },
  {
    path: "CrossSubjectSupervisorQuota",
    name: "CrossSubjectSupervisorQuota",
    component: () =>
      import(
        "@/views/Home/DataCenter/RiskControlData/CrossSubjectSupervisorQuota/index.vue"
      ),
    meta: {
      title: "下级经销商跨主体督学额度"
    }
  },
  {
    path: "CrossSubjectSupervisorAudit",
    name: "CrossSubjectSupervisorAudit",
    component: () =>
      import(
        "@/views/Home/DataCenter/RiskControlData/CrossSubjectSupervisorAudit/index.vue"
      ),
    meta: {
      title: "跨主体督学申请审核"
    }
  },
  {
    path: "AgentVersionNew",
    name: "AgentVersionNew",
    meta: {
      title: "代理商阶段进销存数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentVersionNew/index.vue")
  },
  {
    path: "AgencyActivation",
    name: "AgencyActivation",
    meta: {
      title: "代理商激活数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgencyActivation/index.vue")
  },
  {
    path: "AgentOrdering",
    name: "AgentOrdering",
    meta: {
      title: "代理商订货数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentOrdering/index.vue")
  },
  {
    path: "Subscription",
    name: "Subscription",
    meta: {
      title: "订阅卡使用记录"
    },
    component: () =>
      import("@/views/Home/DataCenter/BusinessData/Subscription/index.vue")
  },
  {
    path: "transformedData",
    name: "transformedData",
    meta: {
      title: "入门账号转化数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/BusinessData/transformedData/index.vue")
  },
  {
    path: "quotaManagement",
    name: "quotaManagement",
    meta: {
      title: "入门账号购买额度"
    },
    component: () =>
      import("@/views/Home/DataCenter/BusinessData/quotaManagement/index.vue")
  },
  {
    path: "ReportManage/region_campus_sub_achievement",
    name: "region_campus_sub_achievement",
    meta: {
      title: "货款返还对账明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/RegionCampusSubAchievement/index.vue")
  },
  {
    path: "ReportManage/sy_region_cash_back",
    name: "sy_region_cash_back",
    meta: {
      title: "货款返还对账明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/SyRegionCashBack/index.vue")
  },
  {
    path: "ReportManage/campus_sub_stat_detail",
    name: "campus_sub_stat_detail",
    meta: {
      title: "订阅卡返还记录"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/CampusSubStatDetail/index.vue")
  },
  {
    path: "ReportManage/sy_region_sub_fee_rebate",
    name: "sy_region_sub_fee_rebate",
    meta: {
      title: "订阅费返佣对账明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/SyRegionSubFeeRebate/index.vue")
  },
  {
    path: "ReportManage/AngLiRebateDetails",
    name: "AngLiRebateDetails",
    meta: {
      title: "昂立订单返佣对账明细"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AngLiRebateDetails/index.vue")
  },
  {
    path: "SellTransData",
    name: "SellTransData",
    meta: {
      title: "销售转化数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/SellTransData/index.vue")
  },
  {
    path: "ReportManage/store_stock_data_statistic",
    name: "store_stock_data_statistic",
    meta: {
      title: "仓库库存数据统计"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/Inventory/index.vue")
  },
  {
    path: "ReportManage/stock_data_statistic",
    name: "stock_data_statistic",
    meta: {
      title: "商品库存数据统计"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/Commodity/index.vue")
  },
  {
    path: "promotionDashboard",
    name: "promotionDashboard",
    meta: {
      title: "区域推广仪表盘"
    },
    component: () =>
      import("@/views/Home/DataCenter/promotionDashboard/index.vue")
  },
  {
    path: "ReportManage/agent_ddj_rank",
    name: "agent_ddj_rank",
    meta: {
      title: "下级经销商打基础高活"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/HighActivity/index.vue")
  },
  {
    path: "ReportManage/agent_ddj_rank_main",
    name: "agent_ddj_rank_main",
    meta: {
      title: "下级经销商主体打基础考核数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/HighActivityMain/index.vue")
  },
  {
    path: "AgentWarehouse",
    name: "AgentWarehouse",
    component: () =>
      import(
        "@/views/Home/DataCenter/RegionData/AgentWarehouse/index.vue"
      ),
    meta: {
      title: "代理商商品库存统计"
    }
  },
  {
    path: "AgentLifeCycle",
    name: "AgentLifeCycle",
    component: () =>
      import(
        "@/views/Home/DataCenter/RegionData/AgentLifeCycle/index.vue"
      ),
    meta: {
      title: "经销商生命周期报表"
    }
  },
  {
    path: "ActivationCluster",
    name: "ActivationCluster",
    component: () =>
      import(
        "@/views/Home/DataCenter/RiskControlData/ActivationCluster/index.vue"
      ),
    meta: {
      title: "激活聚集地"
    }
  },
  {
    path: "ActivationRate",
    name: "ActivationRate",
    component: () =>
      import(
        "@/views/Home/DataCenter/RiskControlData/ActivationRate/index.vue"
      ),
    meta: {
      title: "经销商异常激活率"
    }
  },
  {
    path: "CollusionRate",
    name: "CollusionRate",
    component: () =>
      import(
        "@/views/Home/DataCenter/RiskControlData/CollusionRate/index.vue"
      ),
    meta: {
      title: "经销商串货率"
    }
  },
  {
    path: "PrivateRate",
    name: "PrivateRate",
    component: () =>
      import(
        "@/views/Home/DataCenter/RiskControlData/PrivateRate/index.vue"
      ),
    meta: {
      title: "经销商私下率"
    }
  },
  {
    path:"ActivationLocation",
    name:"ActivationLocation",
    component:()=>
      import(
        "@/views/Home/DataCenter/RiskControlData/ActivationLocation/index.vue"
      ),
    meta: {
      title:  "学习机活跃地"
    }
  },
  {
    path:"CrossRegActiveEquipment",
    name:"CrossRegActiveEquipment",
    component:()=>
      import(
        "@/views/Home/DataCenter/RiskControlData/CrossRegActiveEquipment/index.vue"
      ),
    meta: {
      title:  "下级经销商跨区域活跃设备"
    }
  },
  {
    path:"SecActivationCluster",
    name:"SecActivationCluster",
    component:()=>
      import(
        "@/views/Home/DataCenter/RiskControlData/SecActivationCluster/index.vue"
      )
  },
  {
    path: "StudentRealName",
    name: "StudentRealName",
    meta: {
      title: "下级经销商学员实名率"
    },
    component: () =>
      import("@/views/Home/DataCenter/RiskControlData/StudentRealName/index.vue")
  },
  {
    path: "AbnormalProportion",
    name: "AbnormalProportion",
    meta: {
      title: "下级经销商疑似异常账号占比"
    },
    component: () =>
      import("@/views/Home/DataCenter/RiskControlData/AbnormalProportion/index.vue")
  },
  {
    path: "ExceptionDetails",
    name: "ExceptionDetails",
    meta: {
      title: "下级经销商疑似异常账号明细"
    },
    component: () =>
      import("@/views/Home/DataCenter/RiskControlData/ExceptionDetails/index.vue")
  },
  {
    path: "CollectDetails",
    name: "CollectDetails",
    meta: {
      title: "下级经销商人脸异常采集明细"
    },
    component: () =>
      import("@/views/Home/DataCenter/RiskControlData/CollectDetails/index.vue")
  },
  {
    path: "EquipmentValue",
    name: "EquipmentValue",
    meta: {
      title: "设备价值明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/ReconciliationData/EquipmentValue/index.vue"
      )
  },
  {
    path: "PurchaseValue",
    name: "PurchaseValue",
    meta: {
      title: "采购订单价值明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/ReconciliationData/PurchaseValue/index.vue"
      )
  },
  {
    path: "StarAgentOperation",
    name: "StarAgentOperation",
    meta: {
      title: "星级经销商运营表"
    },
    component: () =>
      import("@/views/Home/DataCenter/StarAgentOperation/index.vue"
      )
  },
  {
    path: "DeliverValue",
    name: "DeliverValue",
    meta: {
      title: "发货订单价值明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/ReconciliationData/DeliverValue/index.vue"
      )
  },
  {
    path: "leagueMatchManage",
    name: "leagueMatchManage",
    meta: {
      title: "星级联赛统计表"
    },
    component: () =>
      import("@/views/Home/DataCenter/leagueMatchManage/leagueMatchManage.vue"
      )
  },
  {
    path: "RegionOrderFlowRecord",
    name: "RegionOrderFlowRecord",
    meta: {
      title: "区域订单流转记录"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/RegionOrderFlowRecord/index.vue"
      )
  },
  {
    path: "AgentCrossRegionalSummary",
    name: "AgentCrossRegionalSummary",
    meta: {
      title: "代理商区域内跨区域报备汇总"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentCrossRegionalSummary/index.vue"
      )
  },
  {
    path: "ServiceCrossRegionalSummary",
    name: "ServiceCrossRegionalSummary",
    meta: {
      title: "经销商跨区域报备汇总"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/ServiceCrossRegionalSummary/index.vue"
      )
  },
  {
    path: "RenewalActivationQuantity",
    name: "RenewalActivationQuantity",
    meta: {
      title: "非省代续费激活量考核表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/RenewalActivationQuantity/index.vue"
      )
  },
  {
    path: "CashPaymentStatement",
    name: "CashPaymentStatement",
    meta: {
      title: "区域内现金支付报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/CashPaymentStatement/index.vue"
      )
  },
  {
    path: "partner/customer-order-details",
    name: "CustomerOrderDetails",
    component: () => import('@/views/Home/OperationCenter/Partner/CustomerOrderDetails/index'),
    meta: {
      title: "转介绍客户订单明细"
    }
  },
  {
    path: "partner/introduceCustomerActivation",
    name: "IntroduceCustomerActivation",
    meta: {
      title: "合伙人转介绍客户激活"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/PartnerIntroduceCustomerActivation/index.vue")
  },
];
